import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../shared/button.component';

function PendingSubmissions({ entriesCount, revertEditedCells, submitEditedCells }) {
  return (
    entriesCount > 0 ? (
      <div>
        <span className="text-danger mr-2">
          {`${entriesCount} entries pending submission`}
        </span>
        <Button
          type="button"
          kind="transparent"
          className="a-mx-10"
          onClick={revertEditedCells}
        >
          Revert
        </Button>
        <Button
          type="button"
          kind="primary"
          onClick={submitEditedCells}
        >
          Submit
        </Button>
      </div>
    ) : null
  );
}

PendingSubmissions.propTypes = {
  entriesCount: PropTypes.number.isRequired,
  revertEditedCells: PropTypes.func.isRequired,
  submitEditedCells: PropTypes.func.isRequired,
};

export default PendingSubmissions;
